export default __webpack_public_path__ + "static/media/java-logo.a6c04d79.png";